/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { PharmacyAddressModel } from "./PharmacyAddressModel";

/**
 * User's preferred pharmacy
 */
export interface PreferredPharmacyModel {
  /** Pharmacy identifier */
  id?: string | null;
  /** Pharmacy name */
  name?: string | null;
  /** Pharmacy address */
  address?: PharmacyAddressModel | null;
  /** Primary phone number */
  phone?: string | null;
}
